<div class="modal-content">
    <div class="modal-header">
        <h6 class="modal-title" id="vcenter">{{'dataform.new_component.title'|translate}}</h6>
        <a (click)="modal.close('')" type="button" class="close">×</a>
    </div>
    <div class="modal-body">
        <form class="form" [formGroup]="formComp">
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <select name="component" formControlName="product" [class.is-invalid]="isValid('product')"
                            class="form-control custom-select" id="product">
                            <option value="">{{ 'common.btn.select' | translate }}</option>
                            <option [ngValue]="prd.PRODUCT_ID" *ngFor="let prd of listProduct">
                                {{ prd.PRODUCT_NAME }}
                            </option>
                        </select>
                        <label for="component">{{ 'dataform.new_component.product' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <select name="component" formControlName="component" [class.is-invalid]="isValid('component')"
                            class="form-control custom-select" id="component">
                            <option value="">{{ 'common.btn.select' | translate }}</option>
                            <option [ngValue]="comp.component_id" *ngFor="let comp of listComponents">
                                {{ comp.description }}
                            </option>
                        </select>
                        <label for="component">{{ 'dataform.new_component.components' | translate }}</label>
                    </div>
                </div>

                <div class="col-lg-4">

                    <button [disabled]="!formComp.valid" type="button" class="btn btn-danger claroredbg mr-1"
                        (click)="newInstance()">{{
                        'dataform.new_component.intant_component' | translate }}</button>
                    <button type="button" class="btn btn-danger claroredbg mr-1" (click)="cleanAll()">{{
                        'dataform.new_component.clean' | translate }}</button>
                    <button type="button" class="btn btn-danger claroredbg mr-1" (click)="openDeleteComponent()">{{
                        'dataform.new_component.button.delete_component' | translate }}</button>
                </div>
                <!--  <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <input  name="descriptionEn" 
                                formControlName="descriptionEn"
                                [class.is-invalid]="isValid('descriptionEn')"
                                class="form-control" 
                                id="descriptionEn" 
                                type="text" >
                        <label for="descriptionEn">{{ 'dataform.new_component.descriptionEn' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <input  name="descriptionEs" 
                                formControlName="descriptionEs"
                                [class.is-invalid]="isValid('descriptionEs')"
                                class="form-control" 
                                id="descriptionEs" 
                                type="text" >
                        <label for="descriptionEs">{{ 'dataform.new_component.descriptionEs' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <input  name="descriptionPt" 
                                formControlName="descriptionPt"
                                [class.is-invalid]="isValid('descriptionPt')"
                                class="form-control" 
                                id="descriptionPt" 
                                type="text" >
                        <label for="descriptionPt">{{ 'dataform.new_component.descriptionPt' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <select name="type" 
                                formControlName="type"
                                [class.is-invalid]="isValid('type')"
                                class="form-control custom-select" 
                                id="type" >
                            <option value="">{{ 'common.btn.select' | translate }}</option>
                            <option *ngFor="let type of listAttributeType" value="{{ type.ATTRIBUTE_TYPE_ID }}"> 
                                {{ type.DESCRIPTION }}
                            </option>
                        </select>
                        <label for="type">{{ 'dataform.new_component.type' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <select name="group"
                                formControlName="group"
                                [class.is-invalid]="isValid('group')" 
                                class="form-control custom-select" 
                                id="group" >
                            <option value="">{{ 'common.btn.select' | translate }}</option>
                            <option *ngFor="let group of listAttributeGroup" value="{{ group.ATTRIBUTE_GROUP_ID }}"> 
                                {{ group.DESCRIPTION }}
                            </option>
                        </select>
                        <label for="group">{{ 'dataform.new_component.group' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group has-float-label">
                        <input  name="order" 
                                formControlName="order"
                                [class.is-invalid]="isValid('order')" 
                                class="form-control" 
                                id="order" 
                                type="text" >
                        <label for="order">{{ 'dataform.new_component.order' | translate }}</label>
                    </div>
                </div>
                <div class="col-lg-1">
                    <label for="mandatory" class="custom-control custom-checkbox">
                        <input  name="mandatory" 
                                formControlName="mandatory"
                                [class.is-invalid]="isValid('mandatory')" 
                                class="custom-control-input" 
                                id="mandatory" 
                                type="checkbox">
                        <span class="custom-control-label pt-1">{{ 'dataform.new_component.mandatory' | translate }}</span>
                    </label>
                </div>
                <div class="col-lg-4">
                    <div class="form-group has-float-label">
                        <select name="task"
                                formControlName="task"
                                [class.is-invalid]="isValid('task')"  
                                class="form-control custom-select" 
                                id="task" >
                            <option value="">{{ 'common.btn.select' | translate }}</option>
                            <option *ngFor="let task of listTask" value="{{ task.TAREADEF }}"> 
                                {{ task.DESCRIPTION }}
                            </option>
                        </select>
                        <label for="task">{{ 'dataform.new_component.task' | translate }}</label>
                    </div>
                </div>
                -->
            </div>
        </form>

    </div>


</div>
<ng-template #modalDeleteComponent let-modal>
    <div class="modal-header">
        <h6 class="modal-title" id="vcenter">{{'dataform.new_component.button.delete_component'|translate}}</h6>
        <a (click)="modal.close('')" type="button" class="close">×</a>
    </div>
    <div class="modal-body">
        <p-table [value]="listProjectComponent" [scrollable]="true" [rowsPerPageOptions]="[10, 25, 50]"
            [tableStyle]="{'min-width':'50rem','margin-top':'10px'}" [paginator]="true" [rows]="10"
            [columns]="colsProjectComponent" [totalRecords]="listProjectComponent.length" sortMode="multiple">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns; let i = index" class="ng-table-header"
                        [pSortableColumn]="col.field">
                        {{ col.header }} <p-sortIcon [field]="col.field" *ngIf="i!=4"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns; let i = index">
                        <div *ngIf="i != 4">{{ rowData[col.field] }}
                        </div>
                        <div *ngIf="i == 4">
                            <a (click)="confirmDeleteProjectComponent(rowData)" href="javascript:void(0)"
                                class="claroredtext mr-3 btn-details" data-toggle="modal">
                                <i class="mdi mdi-delete-forever" data-toggle="tooltip" data-placement="top"
                                    ngbTooltip="{{'dataform.new_component.button.delete_component'|translate}}"></i></a>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">{{'common.message.table_empty'| translate}}</td>
                </tr>
            </ng-template>
        </p-table>

    </div>

</ng-template>

<!--Delete Record Popup-->
<ng-template #confirmdelete let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="vcenter">{{ 'common.message.title_delete' | translate }}</h4>
        <a (click)="modal.close('')" type="button" class="close">×</a>
    </div>
    <div class="modal-body">
        <p>{{ 'common.message.subtitle_delete' | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" (click)="modal.close('')" class="btn btn-secondary waves-effect minibutton"
            data-dismiss="modal">{{
            'common.btn.cancel' | translate }}</button>
        <button type="button" (click)="deleteProjectComponent()" class="btn btn-danger waves-effect minibutton"
            data-dismiss="modal">{{ 'common.btn.button_delete' | translate }}</button>
    </div>
</ng-template>
<!--Delete Record Popup-->